'use client';

import {
    TextLink,
    Drawer,
    Heading,
    TextPassage,
    Band,
    Icon,
} from '@petsmart-ui/sparky';
import { useState } from 'react';
import { Divider } from '@libs/common-next';
import { decodeEntityString } from '@libs/algolia';
import type { OfferDetailsProps } from './types';

import './OfferDrawer.scss';

export default function OfferDetails({ details, promoMsg }: OfferDetailsProps) {
    const [drawerOpen, setDrawerOpen] = useState(false);
    return (
        <div className="product-promotion-details">
            <TextLink
                onClick={() => setDrawerOpen(true)}
                className="promo-details"
            >
                Details
            </TextLink>
            <Drawer
                align="right"
                onClose={() => setDrawerOpen(false)}
                isActive={drawerOpen}
            >
                <Drawer.Header>
                    <Heading size="headline" tagName="h2">
                        Offer Details
                    </Heading>
                </Drawer.Header>
                <Drawer.Body>
                    <div className="promo-msg-wrapper">
                        <Band className="promo-msg-icon">
                            <Icon name="tag" size="lg" />
                        </Band>
                        <Heading size="body-lg-bold" tagName="h3">
                            {promoMsg}
                        </Heading>
                    </div>
                    <Divider />
                    <TextPassage className="product-promotion-details-text">
                        <Heading size="body-lg-bold" tagName="h3">
                            Terms and Conditions
                        </Heading>
                        {decodeEntityString(details)}
                    </TextPassage>
                </Drawer.Body>
            </Drawer>
        </div>
    );
}
